import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/registro_sanitario/comercializador';
import Comercializador from './ComercializadorList';


const ms2p = (state) => {
  return {
    ...state.rs_comercializador,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(Comercializador);